// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610190311/js/" + chunkId + "." + {"44":"7578a528","225":"55a7772d","481":"4603ab90","486":"1d12f6e3","770":"23782a21"}[chunkId] + ".0.07051963501988401.chunk.js";
};